// useDeepLinks.js - Replicated from nidoux
import { useEffect } from 'react';
import { isNativeApp } from '../config';

/**
 * Hook to handle deep links when app is opened from external links
 * @param {Function} onDeepLink - Callback function to handle the deep link
 */
export const useDeepLinks = (onDeepLink) => {
  useEffect(() => {
    if (!isNativeApp()) {
      return;
    }

    let listener;

    const setupDeepLinks = async () => {
      try {
        const { App: CapacitorApp } = await import('@capacitor/app');

        listener = await CapacitorApp.addListener('appUrlOpen', (event) => {
          console.log('App opened with URL', event.url);

          const url = new URL(event.url);
          const path = url.pathname;

          if (path.startsWith('/offer/')) {
            const offerId = path.split('/offer/')[1];
            onDeepLink({ type: 'offer', offerId });
          } else {
            onDeepLink({ type: 'home' });
          }
        });
      } catch (error) {
        console.error('Failed to setup deep links', error);
      }
    };

    setupDeepLinks();

    return () => {
      if (listener) {
        listener.remove();
      }
    };
  }, [onDeepLink]);
};

export default useDeepLinks;
